import axios from "axios";

import {grabDatabaseCharacters} from "../grabDatabaseCharacters.js";
import {buildCharacterDatabaseQuery} from "../buildCharacterDatabaseQuery.js";



export function getCharacterDatabaseData(firstLetter,offset,changeCharacterDatabase,showCharacterDatabase,changePaginationOffset,changeCharacterLetter){
    showCharacterDatabase(false);
    //console.log("getCharacterDatabaseData: " + currentPage)

    //whatever gets passed in as the letter and offset, store them in redux.
    //that way on returning to the character area, the user will be on the same letter and number when they left
    changeCharacterLetter(firstLetter);
    changePaginationOffset(offset);

    //set limit here bc it never changes. No need to store it in redux and have the extra property and method to change it
    const limit = 24;
    var characterQuery = buildCharacterDatabaseQuery(firstLetter,limit,offset);
    var characterData;

    axios.get(characterQuery)
    .then(function (response1) {
        //pass in current page here in oreder to pass it to buildPagination() in grabDatabaseCharacters()
        characterData = grabDatabaseCharacters(response1);
        changeCharacterDatabase(characterData);

    })
    .then(function(){
        showCharacterDatabase(true);
    })

}


// WEBPACK FOOTER //
// ./src/components/includes/axios/getCharacterDatabaseData.js